import { Box, Button, Modal } from '@mui/material';
import styled from 'styled-components';

// export const ModalContent = styled(Box)`
//   max-width: 90vw;
//   border-radius: 8px;
//   overflow: hidden;
//   position: relative;
//   padding: 20px 24px;
//   border-radius: 10px;
//   background: #fff;
//   display: flex;
//   flex-direction: column;
//   gap: 24px;

//   &:focus {
//     outline: none !important;
//   }
// `;

export const ModalHead = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const StyledButton = styled(Button)`
  && {
    height: 40px;
    @media (max-width: 640px) : {
      flex: 1;
    }
  }
`;

export const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 0 10px;

  @media (max-width: 959px) {
    padding: 0 10px;
    box-sizing: border-box;
  }
`;

export const ModalContent = styled(Box)`
  max-height: 90vh;
  overflow-y: auto;
  transform: none;

  max-width: 90vw;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  padding: 20px 24px;
  border-radius: 10px;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 24px;

  &:focus {
    outline: none !important;
  }

  @media (max-width: 959px) {
    max-width: min(400px, calc(100vw - 20px));
    width: 100%;
    padding: 16px 20px;
    gap: 20px;
  }
`;

export const StyledControlButton = styled(Button)`
  && {
    width: 100%;
    height: 44px;
  }
`;

export const ModalControlBox = styled.div`
  display: flex;
  gap: 24px;
`;
